import { Component, Input } from '@angular/core';
import { MyEventsProvider } from '../../providers/my-events/my-events';
import { App, ToastController } from 'ionic-angular';
import { ToastHelper } from '../../helpers/toastr-helper';

/**
 * Generated class for the GoToBoothBtnComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'go-to-booth-btn',
  templateUrl: 'go-to-booth-btn.html'
})
export class GoToBoothBtnComponent {

  @Input() boothPin: any;
  @Input() boothName: any;

  constructor(private app: App,private myEventsProvider: MyEventsProvider, private toastCtrl: ToastController) {

  }

  openBooth() {
    this.myEventsProvider.getEvent(this.boothPin)
      .subscribe(res => {
        this.myEventsProvider.joinEvent(res.uuid).subscribe(
          res => {
              this.app.getRootNav().setRoot('EventSwitchPage', {
                  pin: this.boothPin,
                  name: this.boothName
              });
          },
          err => {
            if (err.status === 409) {
              ToastHelper.Show(this.toastCtrl, err.error.message, 3000)
            }
          }
        );
      })

  }

}



// WEBPACK FOOTER //
// ./src/components/go-to-booth-btn/go-to-booth-btn.ts